import { createAction, createAsyncAction } from 'typesafe-actions';
import { FetchModels, ViewsModels } from '../types';

export const FETCH_REVIEWS_PAGE = createAsyncAction(
  'reviews/FETCH_REVIEWS_PAGE/request',
  'reviews/FETCH_REVIEWS_PAGE/success',
  'reviews/FETCH_REVIEWS_PAGE/failure',
  'reviews/FETCH_REVIEWS_PAGE/cancel',
)<undefined, ViewsModels.ReviewsStore, Error, void>();

export const REVIEWS_SORTING_SET = createAction('reviews/SORTING/set')<ViewsModels.ReviewsSort>();
export const REVIEWS_RESET_SORTING = createAction('reviews/SORTING/resetset')();

export const ADD_FILTER_BY_SCORE = createAction('reviews/FILTERS_BY_SCORE/add')<1 | 2 | 3 | 4 | 5>();
export const REMOVE_FILTER_BY_SCORE = createAction('reviews/FILTERS_BY_SCORE/remove')<1 | 2 | 3 | 4 | 5>();
export const REVIEWS_RESET_FILTER_BY_SCORE = createAction('reviews/FILTERS_BY_SCORE/reset')();

export const FETCH_REVIEWS_NEXT_PAGE = createAsyncAction(
  'reviews/FETCH_REVIEWS_NEXT_PAGE/request',
  'reviews/FETCH_REVIEWS_NEXT_PAGE/success',
  'reviews/FETCH_REVIEWS_NEXT_PAGE/failure',
  'reviews/FETCH_REVIEWS_NEXT_PAGE/cancel',
)<FetchModels.ReviewsPaginationProps, ViewsModels.ReviewsStore, Error, void>();
